





































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import BIObject from '@/types/taxcard/BIObject';
import BookingItem from '@/views/taxcard/booking/BookingItem.vue';
import AdditionalMandatoryField from '@/types/validation/AdditionalMandatoryField';
import Booking from '@/types/taxcard/Booking';
import CommuneProjection from '@/types/projections/CommuneProjection';
import BookingOptionOverlay from '@/views/taxcard/booking/BookingOptionOverlay.vue';
import PriceDiscountOptionProjection from '@/types/projections/PriceDiscountOptionProjection';
import CommuneGuestTypeOption from '@/types/taxcard/CommuneGuestTypeOption';

@Component({
  components: {
    BookingItem,
    BookingOptionOverlay,
  },
})
export default class BookingItems extends Vue {
  @Prop(Object)
  public booking!: Booking;

  @Prop(Object)
  public commune!: CommuneProjection;

  @Prop(Array)
  communeGuestTypeOptions!: CommuneGuestTypeOption[];

  @Prop(Boolean)
  public priceProjectionIsLoading!: boolean;

  @Prop(Boolean)
  public toggleDiscountsLoading!: boolean;

  @Prop(Array)
  public additionalMandatoryFields!: AdditionalMandatoryField[];

  @Prop(Number)
  public openBIObjectIndex!: number | null;

  @Prop(Array)
  public prices!: Array<{ price: number; petPrice: number }>;

  public isOptionOverlayOpen: boolean = false;

  public currentOptionToActive: PriceDiscountOptionProjection | null = null;

  public optionOverlaySubmitCallback: null | ((values: { [fieldName: string]: any }) => void) = null;

  @Emit()
  public toggleOpen(index: number): number | null {
    if (this.openBIObjectIndex === index) {
      return null;
    } else {
      return index;
    }
  }

  public isOpen(index: number): boolean {
    return this.openBIObjectIndex === index;
  }

  @Emit()
  public removeBIObject(index: number): number {
    return index;
  }

  public onBIObjectChanged(index: number, bIObject: BIObject): void {
    this.$emit('booking-change', this.booking);
  }

  public onOptionOverlayClose(): void {
    this.isOptionOverlayOpen = false;
    this.optionOverlaySubmitCallback = null;
    this.$forceUpdate();
  }

  public onOptionOverlaySubmit(values: { [fieldName: string]: any }): void {
    if (!this.optionOverlaySubmitCallback) {
      return;
    }
    this.optionOverlaySubmitCallback(values);
    this.onOptionOverlayClose();
  }

  public onOptionActivate({
    option,
    callback,
  }: {
    option?: PriceDiscountOptionProjection;
    callback?: (id: number, values: { [fieldName: string]: any }) => void;
  }): void {
    if (option && callback) {
      this.isOptionOverlayOpen = true;
      this.currentOptionToActive = option;
      this.optionOverlaySubmitCallback = (values: { [fieldName: string]: any }) => callback(option.id, values);
    } else {
      this.$forceUpdate();
    }
  }

  public onUpdatePrices(doRetry: boolean = false): void {
    this.$emit('update-prices', doRetry);
  }

  public onGuestTypeChange(bIObject: BIObject): void {
    this.$emit('guest-type-change', bIObject);
  }

  public onAnonymousChange(isAnonymous: boolean, bIObject: BIObject): void {
    this.$emit('anonymous-change', isAnonymous, bIObject);
  }

  public isChaperone(index: number): boolean {
    if (index === 0) {
      return false;
    }
    const previousBIObject = this.booking.bIObjects[index - 1];
    if (!previousBIObject.bIObjectData.option || Object.keys(previousBIObject.bIObjectData.option).length === 0) {
      return false;
    }

    const field = Object.values(previousBIObject.bIObjectData.option)[0];
    return (
      (field && field.disabilityMarkers && field.disabilityMarkers.includes('B') && field.chaperoneIsHuman) || false
    );
  }
}
